import {validEmail} from "../validators/GenericValidators";
/*
 formCheckEmail
 rule:
 a regular email format like the following sample:
 username@domain.com
 */

//TODO  Ideally move all the validations into the GenericValidators file within the forms.
// Since this method is being reused at multiple places, replacing the logic here to point to GenericValidators - Sriram
const formCheckEmail = email => {
    /*let isValid = false;

  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

  if (re.test(email)) {
    // email is valid
    isValid = true;
  }

  return isValid;*/

    return validEmail(email);
};

export default formCheckEmail;



// WEBPACK FOOTER //
// ./src/utils/forms/form-email-check.js